// 4.  Only enable "Is there evidence of declining..." [isIndividualSkillsDeclined]
// IF "Is there evidence that the primary caregiver.." [isPrimaryCaregiverUnavailable] answer is "No" 
// OR ("Is there evidence that the primary caregiver." [isPrimaryCaregiverUnavailable] ansser is "Yes" 
// AND "Is action required...' [isActionRequiredIn30Days] is "No")

// In GateKeeper Desktop "Is there evidence of declining skill......." is disabled when the first two questions are yes.

// I didn't answer the question, but if you leave the page and come back, it has set itself to no.

// hey there